import { render } from "./active-deliveries.vue?vue&type=template&id=760322d4&scoped=true"
import script from "./active-deliveries.vue?vue&type=script&lang=js"
export * from "./active-deliveries.vue?vue&type=script&lang=js"

import "./active-deliveries.vue?vue&type=style&index=0&id=760322d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760322d4"]])

export default __exports__